import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { listApplications } from '../../api/applications.js'
import { useAuth } from '../../context/AuthContext.jsx'

function getApplicationInitial(name) {
  const trimmedName = String(name || '').trim()
  return trimmedName ? trimmedName.charAt(0).toUpperCase() : 'A'
}

export default function ApplicationsListPage() {
  const navigate = useNavigate()
  const { hasPermission } = useAuth()
  const [state, setState] = useState({
    status: 'loading',
    data: [],
    error: null,
  })

  useEffect(() => {
    let cancelled = false

    listApplications()
      .then((data) => {
        if (!cancelled) {
          setState({
            status: 'ok',
            data,
            error: null,
          })
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({
            status: 'error',
            data: [],
            error,
          })
        }
      })

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="page">
      <div className="pageHeader">
        <div className="buttonGroup mlAuto">
          <Link to="/" className="button buttonGhost">
            Back
          </Link>
          {hasPermission('create_application') ? (
            <Link to="/applications/new" className="button buttonPrimary">
              Create
            </Link>
          ) : null}
        </div>
      </div>

      {state.status === 'loading' && <div className="muted">Loading applications...</div>}

      {state.status === 'error' && (
        <pre className="codeBlock codeBlockError">{String(state.error?.message || state.error)}</pre>
      )}

      {state.status === 'ok' && (
        <section>
          {state.data.length === 0 ? (
            <p className="muted">No applications yet.</p>
          ) : (
            <div className="applicationsGrid" aria-label="Applications list">
              {state.data.map((application) => (
                <button
                  key={application.id}
                  type="button"
                  className="applicationCard"
                  onClick={() => navigate(`/applications/${application.id}`)}
                >
                  <div className="applicationCardImageWrap">
                    {application.icon ? (
                      <img
                        className="applicationCardImage"
                        src={application.icon}
                        alt={`${application.name || 'Application'} icon`}
                        loading="lazy"
                      />
                    ) : (
                      <div className="applicationCardImageFallback" aria-hidden="true">
                        {getApplicationInitial(application.name)}
                      </div>
                    )}
                  </div>
                  <div className="applicationCardBody">
                    <div className="applicationCardTitle">{application.name || 'Untitled application'}</div>
                    <div className="applicationCardPlatform">{application.platform || 'Unknown platform'}</div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </section>
      )}
    </div>
  )
}
